<template>

    <section class="">


        <div class="flex items-center justify-between px-4 py-2 mx-auto max-w-screen-2xl">
           <div>
            <nuxt-img width="128" height="91" class="relative z-20" src="/assets/images/black-logo.svg"
                alt="Lifeboost Coffee Logo" />
           </div>

           <div>
            <button @click="scrollTo('the-products')"
                class="items-center justify-center px-6 py-3.5 font-bold leading-4 text-center text-white hover:shadow-lg hover:opacity-80 font-ginger bg-lifeboost-red rounded-3xl">
                Shop Lifeboost</button>
           </div>
        </div>

       <div class="px-4 py-3 bg-lifeboost-green-100">
        <div class="flex flex-col items-center justify-between px-4 mx-auto max-w-screen-2xl md:gap-y-0 gap-y-2 md:flex-row">
            <div class="text-white ">
                <a href="https://lifeboostcoffee.com/" target="_blank" class="pr-4 text-sm uppercase border-r border-white">lifeboost</a> 
                <span @click="scrollTo('the-products')"
                    class="pl-4 text-sm uppercase cursor-pointer">frosted sugar cookie</span>
            </div>

            <div class="text-sm text-white uppercase">
                <span class="mr-4">CALL US TOLL FREE</span>     <a href="tel:1-800-479-1596">1-800-479-1596 </a>
            </div>
        </div>
       </div>
    </section>

</template>

<script setup>

defineBuilderComponent({
    friendlyName: 'Header',
    ignored: true
})

</script>